import apiClient from '../../services/apiClient';
import { ShareResponse } from '..';
import { LocationResponse } from '../types/location-response';
import { ItemResponse } from '../types/item-response';
import { AssetsResponse } from '../types/asset-response';
import { TransformFilters } from '../../utils';
import { QueryKey } from '@tanstack/react-query';
interface ThirdParty {
  id: number;
  name: string;
}

interface ListTercerosResponse {
  third_party: ThirdParty[];
}

export const ShareAPI = {
  entryManage: async (id: number, token: string): Promise<ShareResponse[]> => {
    const response = await apiClient.put(
      `api/petition/entry/manage/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  listTerceros: async (token: string): Promise<ListTercerosResponse> => {
    const response = await apiClient.get(
      `api/utils/select-tables?keys[]=third_party&filter[third_party_classification]=Órgano Judicial`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  entryTypes: async (): Promise<ShareResponse[]> => {
    const response = await apiClient.get(`api/portal-utils/entry-types`);
    return response.data;
  },
  itemTypes: async (): Promise<ShareResponse[]> => {
    const response = await apiClient.get(`api/utils/select-tables?keys[]=asset_type`);
    return response.data.asset_type;
  },
  deliveryOptions: async (): Promise<ShareResponse[]> => {
    const response = await apiClient.get(`api/portal-utils/entry-deliver`);
    return response.data;
  },
  entryStates: async (): Promise<ShareResponse[]> => {
    const response = await apiClient.get(`api/portal-utils/entry-states`);
    return response.data;
  },

  goodstates: async (): Promise<ShareResponse[]> => {
    const response = await apiClient.get(`api/portal-utils/good-states`);
    return response.data;
  },
  refundstates: async (): Promise<ShareResponse[]> => {
    const response = await apiClient.get(`api/portal-utils/refund-states`);
    return response.data;
  },
  goodsConsumos: async (): Promise<any[]> => {
    const response = await apiClient.get(`api/utils/select-tables?keys[]=consumer_goods`);
    return response.data;
  },

  manageStatus: async (type: string): Promise<ShareResponse[]> => {
    const response = await apiClient.get(`api/portal-utils/model-states/${type}`);
    return response.data;
  },
  manageStatusGoodItemPetition: async (): Promise<ShareResponse[]> => {
    const response = await apiClient.get(`api/portal-utils/model-states/GoodItemPetition`);
    return response.data;
  },

  //DEPENDICY
  dependencies: async (
    { queryKey }: { queryKey: QueryKey; }
  ): Promise<ShareResponse[]> => {
    const [, filters] = queryKey as [string, Partial<ShareResponse[]>?];
    const transformedFilters = TransformFilters(filters);

    const response = await apiClient.get(
      `api/dependencies?paginate=0&filter[status_id]=1`,
      {
        params: { ...transformedFilters },
      }
    );
    return response.data;
  },
  dependenciesIdUser: async (
    { queryKey }: { queryKey: QueryKey; }
  ): Promise<ShareResponse[]> => {

    const response = await apiClient.get(
      `api/portal-utils/getDependenciesUser/?user_id=${queryKey[1]}`,
    );

    return response.data;
  },

  //AREA
  areas: async (): Promise<ShareResponse[]> => {
    const response = await apiClient.get(
      `api/area?paginate=0&filter[status_id]=1`
    );
    return response.data;
  },

  //SEDES
  sedes: async (): Promise<ShareResponse[]> => {
    const response = await apiClient.get(
      `api/utils/select-tables?keys[]=sectionals`
    );
    const data: any = [...response.data.sectionals]
    return data;
  },

  //SUPERVISORES
  supervisors: async (
    { queryKey }: { queryKey: QueryKey; }
  ): Promise<ShareResponse[]> => {
    const [, filters] = queryKey as [string, Partial<ShareResponse>];
    const transformedFilters = TransformFilters(filters);

    const response = await apiClient.get(
      `api/utils/select-tables?keys[]=users`,
      {
        params: { ...transformedFilters },
      }
    );
    return response?.data.users;
  },

  //SECTIONALS
  sectionals: async (
    { queryKey }: { queryKey: QueryKey; }
  ): Promise<ShareResponse[]> => {
    const [, filters] = queryKey as [string, Partial<ShareResponse>];
    const transformedFilters = TransformFilters(filters);

    const response = await apiClient.get(
      `api/utils/select-tables?keys[]=sectionals`,
      {
        params: { ...transformedFilters },
      }
    );
    return response?.data.sectionals;
  },

  //ACTIVOS
  assets: async (
    { queryKey }: { queryKey: QueryKey; }
  ): Promise<any> => {
    const [, filters] = queryKey as [string, Partial<AssetsResponse>?];
    const transformedFilters = TransformFilters(filters);

    const response = await apiClient.get(
      `api/utils/select-tables?keys[]=assets_data`,
      {
        params: { ...transformedFilters },
      }
    );

    return response?.data?.assets_data;
  },
  assetsAll: async (
    { queryKey }: { queryKey: QueryKey; }
  ): Promise<any> => {
    const [, filters] = queryKey as [string, Partial<AssetsResponse>?];
    const transformedFilters = TransformFilters(filters);

    const response = await apiClient.get(
      `api/asset`,
      {
        params: { ...transformedFilters },
      }
    );

    return response?.data;
  },
  assetsConsumo: async (
  ): Promise<any> => {
    const response = await apiClient.get(
      `api/utils/select-tables?keys[]=consumer_goods`,
    );
    return response?.data.consumer_goods;
  },
  items: async (
    { queryKey }: { queryKey: QueryKey; }
  ): Promise<any> => {
    const [, filters] = queryKey as [string, Partial<AssetsResponse>?];
    const transformedFilters = TransformFilters(filters);

    const response = await apiClient.get(
      `api/utils/select-tables?keys[]=items`,
      {
        params: { ...transformedFilters },
      }
    );

    return response?.data?.items;
  },

  assetsList: async (
    { queryKey }: { queryKey: [string, Partial<AssetsResponse> & { page?: number; rows?: number }] }
  ): Promise<any> => {
    const [, filters] = queryKey;
    const transformedFilters = TransformFilters(filters);

    const { page, rows } = filters || {};

    const response = await apiClient.get(`api/asset`, {
      params: {
        ...transformedFilters,
        paginate: true,      
        page,
        rows
      },
    });

    return response?.data;
  },
  
  GoodConsumerList: async (
    { queryKey }: { queryKey: QueryKey; }
  ): Promise<any> => {
    const [, filters] = queryKey as [string, Partial<AssetsResponse>?];
    const transformedFilters = TransformFilters(filters);

    const response = await apiClient.get(
      `api/consumer-good`,
      {
        params: { ...transformedFilters },
      }
    );

    return response?.data?.data;
  },

  //LOCATION
  location: async (): Promise<LocationResponse[]> => {
    const response = await apiClient.get(
      `api/utils/select-tables?filter[status_id]=1&keys[]=locations`
    );

    return response?.data?.locations;
  },
  //ITEMS
  item: async (): Promise<ItemResponse[]> => {
    const response = await apiClient.get(
      `api/item?paginate=0&filter[status_id]=1`
    );
    return response.data;
  },
  // ADVANCE FILTERS
  advanceFilters: async (key: string): Promise<ItemResponse[]> => {
    const response = await apiClient.get(
      `api/utils/advance-filters/${key}`
    );
    return response.data;
  },
  // GOODS CONSUMER GOODS
  goodsConsumerGoods: async (): Promise<ItemResponse[]> => {
    const response = await apiClient.get(
      `api/petition/good/consumer-goods`
    );
    return response.data;
  },
  //gestor
  manageGoodConsumerItems: async (body: any, id: number | string): Promise<ItemResponse[]> => {
    const response = await apiClient.post(
      `api/petition/good/replace-items/${id}`,
      body,
    );
    return response.data;
  },
  updateGestorItems: async (body: any, id: number | string, token: string): Promise<ItemResponse[]> => {
    const response = await apiClient.put(
      `api/petition/good/manage-items/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  updateGestorStatus: async (body: any, token: string, id: number | undefined): Promise<ItemResponse[]> => {
    const response = await apiClient.put(
      `api/petition/good/manage/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  updateGestorConceptsStatus: async (body: any, token: string, id: number | undefined): Promise<ItemResponse[]> => {
    const response = await apiClient.put(
      `api/petition/concept/manage/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  approveConcepts: async (body: any, token: string, id: number | undefined): Promise<ItemResponse[]> => {
    const response = await apiClient.put(
      `api/petition/concept/approve/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  returnConcepts: async (body: any, token: string, id: number | undefined): Promise<ItemResponse[]> => {
    const response = await apiClient.put(
      `api/petition/concept/return-technician/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  addEvalConcept: async (body: any, token: string, id: number | undefined): Promise<ItemResponse[]> => {
    const response = await apiClient.put(
      `api/petition/concept/addEval/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  updateGestorEntryStatus: async (body: any, token: string, id: number | undefined): Promise<ItemResponse[]> => {
    const response = await apiClient.put(
      `api/petition/entry/manage/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  updateEntryStatusDevuelto: async (body: any, token: string, id: number | undefined): Promise<AssetsResponse[]> => {
    const response = await apiClient.post(
      `api/petition/entry/update/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        },
      }
    );
    return response.data;
  },

  // GET DEPENDECIES BY USER LOGGED
  getDependeciesByUserLogged: async (
    { queryKey }: { queryKey: QueryKey }
  ): Promise<ShareResponse[]> => {
    const [, filters] = queryKey as [string, Record<string, any>];

    const response = await apiClient.get(
      'api/portal-utils/getDependenciesUser',
      {
        params: { ...filters },
      }
    );
    return response.data;
  },



  // GET DEPENDECIES BY USER LOGGED
  getExportFiles: async (id: number): Promise<ShareResponse[]> => {
    const response = await apiClient.get(
      `api/petition/good/documents/${id}`
    );

    return response.data;
  },

  // GET ADDITIONS FROM ASSET
  getAddittions: async (assetId: string): Promise<ShareResponse[]> => {
    const response = await apiClient.get(
      `api/asset/related/${assetId}`
    );

    return response.data;
  },

  fetchParameters: async (keys: string) => {
    try {
      const { data } = await apiClient.get(`api/utils/select-tables?${keys}`);

      return data;
    } catch (error) {
      console.error('Error fetching parameters:', error);
      return null;
    }
  },
};
